import { APP_URL } from "../lib/config";

type Props = {
  tenantId: string;
  tenantName: string;
  rewardLabel: string;
  ticketsForReward: number;
};

export function TenantShareKit({ tenantId, tenantName, rewardLabel, ticketsForReward }: Props) {
  const url = `${APP_URL}/?join=${encodeURIComponent(tenantId)}`;
  const message = `${tenantName} tiene programa de fidelizacion! Junta ${ticketsForReward} compras y obtienes ${rewardLabel}. Sumate aqui: ${url}`;
  const igCaption = `${tenantName} ahora premia tus compras. ${ticketsForReward} visitas = ${rewardLabel}. Link en bio o entra a ${url}`;
  const tiktokCaption = `Descubri ${tenantName} ${rewardLabel} cada ${ticketsForReward} visitas`;

  const copy = async (text: string, label: string) => {
    try {
      await navigator.clipboard.writeText(text);
      alert(`${label} copiado.`);
    } catch {
      /* ignore */
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-3 gap-2">
        <a
          href={`https://wa.me/?text=${encodeURIComponent(message)}`}
          target="_blank"
          rel="noreferrer"
          className="rounded-xl bg-green-600 px-3 py-2 text-center text-xs font-medium text-white"
        >
          WhatsApp
        </a>
        <button
          onClick={() => copy(igCaption, "Caption Instagram")}
          className="rounded-xl bg-pink-600 px-3 py-2 text-xs font-medium text-white"
        >
          IG caption
        </button>
        <button
          onClick={() => copy(tiktokCaption, "Caption TikTok")}
          className="rounded-xl bg-black px-3 py-2 text-xs font-medium text-white"
        >
          TikTok
        </button>
      </div>
      <button
        onClick={() => copy(url, "Link directo")}
        className="rounded-xl bg-leaf-50 px-3 py-2 text-xs text-leaf-800 ring-1 ring-leaf-200"
      >
        Copiar link directo
      </button>
    </div>
  );
}
